import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import {
  FiBarChart2,
  FiSearch,
  FiShield,
  FiSmartphone,
  FiFilter,
  FiLock,
} from "react-icons/fi";

const VideoFrame = () => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleSubtext = (index) => {
    setActiveItem((prev) => (prev === index ? null : index));
  };

  return (
    <VideoContainer>
      {/* TITLE back on top and centered */}
      <TopHeader>
        <h2>Dlaczego warto wybrać analizyiraporty.pl?</h2>
      </TopHeader>

      {/* 2-col: image left | content right */}
      <ContentWrapper>
        <ImageWrapper>
          <img src="./banner6.jpg" alt="Jak to działa - ilustracja" />
        </ImageWrapper>

        <TextContainer>
          <LateralWrapper>
            <LateralMenu>
              {lateralItems.map((item, index) => (
                <LateralItem key={index} onClick={() => toggleSubtext(index)}>
                  <ItemTitle>
                    <IconWrapper>{item.icon}</IconWrapper>
                    <span>{item.title}</span>
                    <Arrow $isOpen={activeItem === index}>
                      {activeItem === index ? "▲" : "▼"}
                    </Arrow>
                  </ItemTitle>

                  <Subtext $isVisible={activeItem === index}>
                    {item.subtext}
                  </Subtext>
                </LateralItem>
              ))}
            </LateralMenu>
          </LateralWrapper>
        </TextContainer>
      </ContentWrapper>

      {/* BUTTON centered like before */}
      <ButtonBar>
        <CTAButton href="/register-demo">Zarezerwuj Demo →</CTAButton>
      </ButtonBar>
    </VideoContainer>
  );
};

export default VideoFrame;

/* ---------- content ---------- */

const lateralItems = [
  {
    title: "Automatyczne przetwarzanie danych JPK VAT",
    subtext:
      "Nasz system samodzielnie odczytuje strukturę pliku JPK VAT i analizuje zawarte w nim dane. Dzięki temu eliminujesz potrzebę ręcznego przetwarzania i redukujesz ryzyko błędów.",
    icon: <FiBarChart2 />,
  },
  {
    title: "Zaawansowane raportowanie czasowe",
    subtext:
      "Twórz raporty dzienne, miesięczne i roczne na podstawie jednego pliku. System automatycznie grupuje dane w czasie, dając pełny obraz aktywności firmy.",
    icon: <FiSearch />,
  },
  {
    title: "Weryfikacja kontrahentów w zewnętrznych bazach",
    subtext:
      "Dzięki integracjom z publicznymi i komercyjnymi rejestrami możesz sprawdzić wypłacalność, zmiany w zarządzie, dane rejestrowe i sprawozdania finansowe swoich kontrahentów.",
    icon: <FiShield />,
  },
  {
    title: "Dostępność na wszystkich urządzeniach",
    subtext:
      "Aplikacja działa w przeglądarce – bez potrzeby instalacji. Korzystaj z niej wygodnie na komputerze, smartfonie czy tablecie – kiedy i gdzie chcesz.",
    icon: <FiSmartphone />,
  },
  {
    title: "Intuicyjne filtrowanie i eksport danych",
    subtext:
      "Zaawansowane filtry umożliwiają szybkie przeszukiwanie danych według wybranych kryteriów. Możesz łatwo eksportować wyniki do plików Excel lub PDF.",
    icon: <FiFilter />,
  },
  {
    title: "Najwyższy poziom bezpieczeństwa danych",
    subtext:
      "Twoje dane są przechowywane i przetwarzane na bezpiecznych serwerach, chronionych certyfikatem SSL, firewallami i ochroną przed atakami DDoS. Działamy zgodnie z zasadami ochrony danych osobowych i zgodnie z obowiązującym prawem.",
    icon: <FiLock />,
  },
];

/* ---------- styles ---------- */

const fadeInExpand = keyframes`
  from { opacity: 0; transform: scaleY(0); }
  to   { opacity: 1; transform: scaleY(1); }
`;

const VideoContainer = styled.div`
  padding: 1rem 2rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  backdrop-filter: blur(30px);

  /* If you want fully transparent page bg here instead:
     background: transparent; backdrop-filter: none; */
`;

/* Title centered like before */
const TopHeader = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 2rem 0;
  text-align: center;

  h2 {
    font-size: 2.2rem;
    color: #1f2937;
    font-weight: 800;
    margin: 0;

    @media (max-width: 768px) {
      font-size: 1.8rem;
      line-height: 1.3;
    }
  }
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.15fr; /* image | content */
  gap: 2rem;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr; /* stack on mobile */
    padding: 1rem;
  }
`;

const ImageWrapper = styled.div`
  text-align: center;

  img {
    width: 100%;
    height: 55vh;
    max-height: 520px;
    border-radius: 12px;
    object-fit: cover; /* use 'contain' to avoid cropping */
    display: block;
  }

  @media (max-width: 1024px) {
    img { height: 40vh; }
  }
`;

const TextContainer = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  display: flex;
  justify-content: center;

  @media (max-width: 1024px) {
    padding: 0;
  }
`;

const LateralWrapper = styled.div`
  width: 100%;
  max-width: 700px;  /* keeps line length pleasant */
  text-align: center;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const LateralMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const LateralItem = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.95;
  }
`;

const ItemTitle = styled.div`
  display: grid;
  grid-template-columns: 2.2rem 1fr 1.5rem;
  align-items: center;
  gap: 1rem;
  font-size: 1.2rem;
  color: #1f2937;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: color 0.3s ease;

  ${LateralItem}:hover & {
    color: #3bc3cc;
  }

  @media (max-width: 768px) {
    font-size: 1.05rem;
  }
`;

const IconWrapper = styled.div`
  font-size: 2rem;
  color: #3bc3cc;
  text-shadow: 0 0 8px rgba(59, 195, 204, 0.4);
  display: flex;
  align-items: center;
  min-width: 2.5rem;
  transition: color 0.3s ease, text-shadow 0.3s ease;

  ${LateralItem}:hover & {
    color: #000;
    text-shadow: 0 0 12px rgba(0, 0, 0, 0.4);
  }
`;

/* transient prop (JS): $isOpen */
const Arrow = styled.span`
  font-size: 1.5rem;
  color: #1f2937;
  transition: transform 0.25s ease, color 0.3s ease;
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(180deg)" : "none")};

  ${LateralItem}:hover & {
    color: #3bc3cc;
  }
`;

/* transient prop (JS): $isVisible */
const Subtext = styled.p`
  font-size: 1rem;
  color: #4b5563;
  margin-top: 0.75rem;
  line-height: 1.7;
  padding-left: 3rem;
  text-align: left;
  transform-origin: top;
  animation: ${({ $isVisible }) => ($isVisible ? fadeInExpand : "none")} 0.3s ease;
  max-height: ${({ $isVisible }) => ($isVisible ? "500px" : "0")};
  transition: max-height 0.3s ease, opacity 0.3s ease;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  overflow: hidden;

  @media (max-width: 768px) {
    font-size: 0.95rem;
    padding-left: 2rem;
  }
`;

/* Button centered like before */
const ButtonBar = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem 2.5rem;
  text-align: center;
`;

const CTAButton = styled.a`
  display: inline-block;
  margin-top: 0;            /* handled by ButtonBar spacing */
  padding: 1rem 3rem;
  background-color: #3bc3cc;
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: black;
    transform: scale(1.05);
    box-shadow: 0 10px 20px rgba(59, 64, 208, 0.3);
  }

  &:active {
    background-color: #2e3192;
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.9rem 2rem;
    width: auto;           /* keep natural size */
    text-align: center;
  }
`;
